export default __webpack_public_path__ + "static/media/No2Closed.92195132.jpg";